import _kebabCase from "lodash/kebabCase";
import _snakeCase from "lodash/snakeCase";
import _lowerCase from "lodash/lowerCase";
import _upperCase from "lodash/upperCase";
import _camelCase from "lodash/camelCase";
/**
 * Recursively remaps every key of a plain object through a lodash case
 * conversion (`camelCase`/`upperCase`/`lowerCase`/`snakeCase`/`kebabCase`),
 * with a `depth` cutoff for how far to recurse into nested object values —
 * used to bridge PHP/MySQL snake_case payloads and JS camelCase call sites (or
 * the reverse).
 *
 * Part of the mibaby-common shared utilities & types component — see docs/wiki/System/shared/mibaby-common.md.
 */

function mapKeys(obj, fn, depth = 0) {
  return Object.fromEntries(Object.entries(obj).map(([key, val]) => [fn(key), depth && Object(val) === val ? mapKeys(val, fn, depth - 1) : val]));
}
export const camelCaseKeys = (obj, depth = 0) => mapKeys(obj, _camelCase, depth);
export const upperCaseKeys = (obj, depth = 0) => mapKeys(obj, _upperCase, depth);
export const lowerCaseKeys = (obj, depth = 0) => mapKeys(obj, _lowerCase, depth);
export const snakeCaseKeys = (obj, depth = 0) => mapKeys(obj, _snakeCase, depth);
export const kebabCaseKeys = (obj, depth = 0) => mapKeys(obj, _kebabCase, depth);
export default mapKeys;
//# sourceMappingURL=mapKeys.mjs.map